exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_section[data-v-429f3187]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-top:15px}.confirm_btn[data-v-429f3187]{padding:5px 20px;line-height:20px;height:28px}.custom_form[data-v-429f3187] .mint-cell-wrapper{background-size:120% 0}", ""]);

// exports
